import React from "react"
import Layout from '../components/layout'
import { FaFilePdf, FaLinkedin, FaTwitterSquare, FaGithubSquare } from 'react-icons/fa';

export default () => <Layout>
  <div id="home">
    <h1>Dan Nuttall</h1>
    <p>
      Freelance Software Engineer, available for work in Manchester, London, or Remotely.
    </p>
    <p>
      Interested in helping clients build well-structured, sustainable products that their customers love. I especially enjoy collaborating with product owners and prototype development.
    </p>
    <p>
      I've recently worked with <a href="https://www.raspberrypi.org/">Raspberry Pi</a>, <a href="https://spyscape.com/">
        SPYSCAPE</a>, and <a href="https://www.bbc.co.uk/rd">
        BBC Research and Development</a>.
    </p>
    <div id="social">
      <a title="LinkedIn" href="https://linkedin.com/in/dan-nuttall-182ba5165/">
        <FaLinkedin />
      </a>
      <a title="Twitter" href="https://twitter.com/pixelblend">
        <FaTwitterSquare />
      </a>
      <a title="Github" href="https://github.com/pixelblend">
        <FaGithubSquare />
      </a>
      { false &&
        <a title="My CV as a PDF" href="/dan-nuttall-cv.pdf">
          <FaFilePdf />
        </a>
      }
    </div>
  </div>
</Layout>
